import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Program } from "src/app/model/program";
import { OrganizationInfo } from "src/app/model/organization";
import { Lookup } from "src/app/model/lookup";

import { CommonService } from "src/app/services/common.service";
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';


declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.css']
})
export class ProgramComponent implements OnInit {

resourcesDropdownList = [];
resourcedropdownSettings = {};
languageDropdownList = [];
languagedropdownSettings = {};
public selectedItems: Lookup[];
zipCodeDropdownList = [];
dropdownSettings = {};
ageTypeDropdownList = [];
ageTypedropdownSettings = {};
private _organizationInfo: OrganizationInfo;

 @ViewChild('programForm')
  public programForm: NgForm;

 @Input()
  public get organizationInfo(): OrganizationInfo { return this._organizationInfo; }
  public set organizationInfo(v: OrganizationInfo) { this._organizationInfo = v; }
  constructor(private _commonService: CommonService) { }



  ngOnInit() {

    let that = this;
    
    this.selectedItems = [];
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      enableCheckAll: true
    };

this.resourcedropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: false
    };
  
this.ageTypedropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      enableCheckAll: false
    };
  
that.ageTypeDropdownList = this._commonService.getAgeTypes();
  // this._commonService.getAgeTypes().subscribe(res => {
  //   let resourlist  = res;
  //   that.ageTypeDropdownList = res;
  //   that.ageTypeDropdownList.sort(function(a,b){
  //   return a.Value.localeCompare(b.Value);})
  // });


  this._commonService.getallResources().subscribe(res => {
    let resourlist  = res;
    that.resourcesDropdownList = res;
    that.resourcesDropdownList.sort(function(a,b){
    return a.Value.localeCompare(b.Value);})
  });

this._commonService.getallZipcodes().subscribe(res => {
      this.zipCodeDropdownList = res;
    });

    this.languageDropdownList = this._commonService.getLanguages();  
  }

onAgeTypeItemSelect(item: any, program: Program, index: number) {
    console.log(item);
   // this.organizationInfo.Programs[index].ZipCodes.push(item);
    //this.selectedItems.push(item);
    if(this.organizationInfo.Programs[index].AgeTypes.length > 0) {
      for(let i = 0; i < this.organizationInfo.Programs[index].AgeTypes.length; i++) {
        if(this.organizationInfo.Programs[index].AgeTypes[i].Id == '5') {
          this.organizationInfo.Programs[index].AgeTypes = [];
          this.organizationInfo.Programs[index].AgeTypes.push(item);
        }
      }
    }
    if(item.Id == '5') {
      this.organizationInfo.Programs[index].AgeTypes = [];
      this.organizationInfo.Programs[index].AgeTypes.push(item);
     // this.organizationInfo.Programs[index].AgeTypes = this.organizationInfo.Programs[index].AgeTypes.filter(obj => obj !== item);
    }
    this.updateAgeTypeBorderColor(program, index);
    
  }
  onAgeTypeSelectAll(items: any, program: Program, index: number) {
    for(let i = 0 ; i< items.length; i++) {

      this.organizationInfo.Programs[index].AgeTypes.push(items[i]);
    }
    this.updateAgeTypeBorderColor(program, index);
    console.log(items);
  }

onAgeTypeItemDeSelect(item: any, program: Program, index: number) {

this.organizationInfo.Programs[index].AgeTypes = this.organizationInfo.Programs[index].AgeTypes.filter(obj => obj !== item);
this.updateAgeTypeBorderColor(program, index);
    console.log(item);
  }

onResourceItemSelect(item: any, program: Program, index: number) {
    console.log(item);
   // this.organizationInfo.Programs[index].ZipCodes.push(item);
    //this.selectedItems.push(item);
    if( item.Id == 38 || item.Id == 39 || item.Id == 40 ) {
      this.organizationInfo.Programs[index].FreeOfCharge = 'Yes'
      program.FreeOfCharge = 'Yes';
      this.organizationInfo.Programs[index].CanDisableCharge = true;
      program.CanDisableCharge = true;
    }
    else {
      program.CanDisableCharge = false;
      this.organizationInfo.Programs[index].CanDisableCharge = false;
    }
    this.updateResourceBorderColor(program, index);
    
  }
  onResourceSelectAll(items: any, program: Program, index: number) {
    for(let i = 0 ; i< items.length; i++) {
      this.organizationInfo.Programs[index].Resources.push(items[i]);
    }
    this.updateResourceBorderColor(program, index);
    console.log(items);
  }

onResourceItemDeSelect(item: any, program: Program, index: number) {

this.organizationInfo.Programs[index].Resources = this.organizationInfo.Programs[index].Resources.filter(obj => obj !== item);
program.CanDisableCharge = false;
this.organizationInfo.Programs[index].CanDisableCharge = false;
this.updateResourceBorderColor(program, index);
    console.log(item);
  }

onLanguageItemSelect(item: any, program: Program, index: number) {
    console.log(item);
   // this.organizationInfo.Programs[index].ZipCodes.push(item);
    //this.selectedItems.push(item);
    this.updateLanguageBorderColor(program, index);
  }
  onLanguageSelectAll(items: any, program: Program, index: number) {
    for(let i = 0 ; i< items.length; i++) {
      this.organizationInfo.Programs[index].Languages.push(items[i]);
    }
    console.log(items);
    this.updateLanguageBorderColor(program, index);
  }

onLanguageItemDeSelect(item: any, program: Program, index: number) {

this.organizationInfo.Programs[index].Languages = this.organizationInfo.Programs[index].Languages.filter(obj => obj !== item);

    console.log(item);
    this.updateLanguageBorderColor(program, index);
  }

onItemSelect(item: any, program: Program, index: number) {
    console.log(item);
   // this.organizationInfo.Programs[index].ZipCodes.push(item);
    //this.selectedItems.push(item);
    this.updateZipCodeBorderColor(program, index);
  }
  onSelectAll(items: any, program: Program, index: number) {
    for(let i = 0 ; i< items.length; i++) {
      this.organizationInfo.Programs[index].ZipCodes.push(items[i]);
    }
    console.log(items);
     this.updateZipCodeBorderColor(program, index);
  }

onItemDeSelect(item: any, program: Program, index: number) {

this.organizationInfo.Programs[index].ZipCodes = this.organizationInfo.Programs[index].ZipCodes.filter(obj => obj !== item);

    console.log(item);
     this.updateZipCodeBorderColor(program, index);
  }


public removeProgram(i: number): void {
    this.organizationInfo.Programs.splice(i, 1);
  }

public AddProgram () {
  let that = this;
  this.organizationInfo.Programs.push(new Program());
  setTimeout(() => {
    that.initialize();
    }, 300);
  
//   if(this.organizationInfo.Programs.length < 5) {
// this.organizationInfo.Programs.push(new Program());
//   } else {
//     $('#maxPrograms').modal('show');
//   }
  
}

public getSortedList (list: Lookup[]) : any{
list.sort(function(a,b){
    return a.Value.localeCompare(b.Value);
})
}
public onProgramCPEmailValidate(emailaddress:string)
    {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
 
      //Update the model after validation to check if the save button has to be disabled or not.
      return (emailaddress == ''  || !re.test(emailaddress))?true:false;
    }

public updateAgeTypeBorderColor(program: Program, i : number) {
      //prog{{rowIndex}}Resources
       if (program.AgeTypes.length == 0) {
         $(".prog" + i + "AgeTypes .dropdown-btn").css({ "border-color": "#a94442" });
       } else {
       $(".prog" + i + "AgeTypes .dropdown-btn").css({ "border-color": "#adadad" });
       }
    }

    public updateResourceBorderColor(program: Program, i : number) {
      //prog{{rowIndex}}Resources
       if (program.Resources.length == 0) {
         $(".prog" + i + "Resources .dropdown-btn").css({ "border-color": "#a94442" });
       } else {
       $(".prog" + i + "Resources .dropdown-btn").css({ "border-color": "#adadad" });
       }
    }
    public updateLanguageBorderColor(program: Program, i : number) {
       if (program.Resources.length == 0) {
            $(".prog" + i + "Languages .dropdown-btn").css({ "border-color": "#a94442" });
       } else {
            $(".prog" + i + "Languages .dropdown-btn").css({ "border-color": "#adadad" });
       }
    }
    public updateZipCodeBorderColor(program: Program, i : number) {
       if (program.Resources.length == 0) {
         //prog{{rowIndex}}Resources
          $(".prog" + i + "Zipcodes .dropdown-btn").css({ "border-color": "#a94442" });
       } else {
            $(".prog" + i + "Zipcodes .dropdown-btn").css({ "border-color": "#adadad" });
       }
    }

    public initialize() {

    for(let i = 0 ; i< this.organizationInfo.Programs.length; i++) {
     this.updateResourceBorderColor(this.organizationInfo.Programs[i],i);
     this.updateLanguageBorderColor(this.organizationInfo.Programs[i], i);
     this.updateZipCodeBorderColor(this.organizationInfo.Programs[i], i);
     this.updateAgeTypeBorderColor(this.organizationInfo.Programs[i], i);
    }
    //$(".txtResources .dropdown-btn").css({ "border-color": "#a94442" });

    }
}
